<ng-container *transloco="let t">
<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center">{{ (task | taskText:'docType') || (task | taskText:'description') }}</h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()" aria-label="Close"></button>
</div>



<div class="modal-body modal-content">
  @if (loading) {
    <div class="card-px text-center py-20 my-10">
      <p class="text-gray-400 fs-4 fw-bold mb-10">{{ t('portal.tasks.pleaseWait') }}</p>
      <i class="fas fa-circle-notch fa-4x fa-spin"></i>
    </div>
  }

  <iframe class="webview-iframe h-100" [src]="websiteUrlSafe" (load)="onWebviewLoad()"
    sandbox="allow-scripts allow-forms allow-same-origin allow-popups" referrerpolicy="no-referrer" allowfullscreen>
  </iframe>
</div>

<div class="modal-footer flex-end">
  <button  type="button" class="btn btn-white me-3"
    (click)="activeModal.dismiss()">{{ t('common.cancel') }}</button>
  <button type="submit" class="btn btn-primary" (click)="onComplete()" >
    <span class="indicator-label">{{ t('portal.tasks.complete') }}</span>
  </button>
</div>
</ng-container>
